import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
// import { isEqual } from 'lodash'
import EventEmitter from '../../../utils/events'

// Actions
import { startOrder, stopOrder } from '../../../actions/orders'
import { triggerPopup } from '../../../actions/backdrop'

// import styles
import './item.scss'

// Components
import OrderActions from '../../../shared/components/ActionMenu/OrderActions'
import ActionMenu from '../../../shared/components/ActionMenu'
import HoverExtent from '../../../shared/components/HoverExtent'
import StopOtherOrders from '../../../shared/components/StopOtherOrders'
import Portal from '../../../shared/components/Portal'
import HoverPopup from '../../../shared/components/HoverPopup'

// Modals
import QualityCheckModal from '../../../shared/modals/QualityCheckModal'
import ReferenceOrderActionModal from '../../../shared/modals/ReferenceOrderActionModal'

// Utils
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
import { isTouchDevice } from '../../../utils/detect'
import { translation, enumtranslate } from '../../../utils/helpers'
import { renderFullDate } from '../../../utils/time'
import { OrderAssessmentIcons } from '../../../shared/elements/icons'

// Taksering
import Taksering from '../../Orders/OrderList/NewItem/Taksering'
import Confirm from '../../../shared/components/Confirm'
import Icon from '../../../shared/elements/icon'

class Item extends PureComponent {

  constructor (props) {
    super(props)
    this.startOrderCount = 0
    this.state = {
      item: undefined,
      quality: {
        open: false,
        data: {}
      },
      stopped: {
        open: false,
        comment: ''
      },
      stopOtherOrders: {
        open: false,
        WorkOnAll: null
      },
      stopOrders: {
        open: false,
        StopAll: null
      },
      openlinkedselector: false,
      checkstart: true,
      startData: {},
      isIExplorer: false,
      isEdge: false,
      isFireFox: false,
      orderReferenceApprove: {
        open: false
      },
      image: ''
    }
    this.updateTime = null
    this.startOrder = this.startOrder.bind(this)
    this.startOrderSuccess = this.startOrderSuccess.bind(this)
    this.stopOrder = this.stopOrder.bind(this)
    this.canClick = this.canClick.bind(this)
    this.checkStartStop = this.checkStartStop.bind(this)
    this.togglePortal = this.togglePortal.bind(this)
    this.render = this.render.bind(this)
    this.goToWorkcard = this.goToWorkcard.bind(this)
    this.goToInspection = this.goToInspection.bind(this)
    this.openReferenceApprove = this.openReferenceApprove.bind(this)
    this.getCircleImages = this.getCircleImages.bind(this)
    this.closeQualityModal = this.closeQualityModal.bind(this)
    this.setStopped = this.setStopped.bind(this)
    this.onReferenceSave = this.onReferenceSave.bind(this)
    this.renderConfirm = this.renderConfirm.bind(this)
    this.onConfirmStart = null
  }

  componentDidMount () {
    this.setState({
      item: this.props.item,
      isIExplorer: this.props.isIExplorer, // navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('like Gecko') !== -1 && navigator.appVersion.indexOf('Apple') === -1 && navigator.appVersion.indexOf('Chrome') === -1,
      isEdge: this.props.isEdge, // navigator.userAgent.indexOf('Edge') > -1,
      isFireFox: this.props.isFireFox, // navigator.userAgent.indexOf('Firefox') > -1
      isTouch: this.props.isTouch !== undefined ? this.props.isTouch : (isTouchDevice() === true || isTouchDevice() > 0)
    }, () => {
      this.checkStartStop(this.props)
      this.setState({
        image: this.getCircleImages(this.props.item)
      })
    })
  }

  componentWillUnmount () {
    EventEmitter.removeListener('OrderStartMenny', this.startOrder.bind(this, true))
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.openStartStop !== this.props.openStartStop) {
      this.checkStartStop(nextProps)
    }
    this.setState({
      item: nextProps.item,
      image: this.getCircleImages(nextProps.item)
    }, () => this.checkStartStop(nextProps))
  }
  togglePortal (e) {
    e.preventDefault()
    this.setState({
      stopped: {
        ...this.state.stopped,
        open: false
      }
    })
    document.removeEventListener('click', this.togglePortal, false)
  }

  goToWorkcard () {
    if (hasAccess([5, 7], this.props.auth.user.UserType)) {
      if (typeof this.props.onStartAsShopLogin !== 'undefined') {
        this.props.onStartAsShopLogin({
          type: 'workcard',
          id: this.state.item.Id,
          step: this.props.step
        })
        return false
      }
    } else {
      this.props.router.push('/orders/' + this.state.item.Id)
    }
  }

  goToInspection () {
    if (hasSubscriptionPermission(this.props.auth, 10, 30)) {
      if (hasAccess([5, 7], this.props.auth.user.UserType)) {
        if (typeof this.props.onStartAsShopLogin !== 'undefined') {
          this.props.onStartAsShopLogin({
            type: 'inspection',
            id: this.state.item.Id,
            step: this.props.step
          })
          return false
        }
      } else {
        this.props.router.push('/orders/' + this.state.item.Id + '/orderinspection')
      }
    }
  }

  stepHasComments (data) {
    let anyComments = false
    data.map((x) => {
      x.ProcessComments.map((val) => {
        if (val.StepComments.length !== 0) anyComments = true
      })
    })
    return anyComments
  }

  checkStartStop (props) {
    if (props.openStartStop) {
      if (typeof this.startStop.click === 'function') {
        this.startStop.click()
        this.props.hasOpendStatrStop()
      }
    }
  }

  startOrder (confirmStart = false) {
    if (typeof confirmStart !== 'boolean') confirmStart = false
    if (hasAccess([5, 7], this.props.auth.user.UserType)) {
      if (typeof this.props.onStartAsShopLogin !== 'undefined') {
        let top = 0
        let steps = document.getElementsByClassName('drag-content scrollbar')
        for (let i = 0; i < steps.length; i++) {
          if (steps[i].dataset.pos === '' + this.props.step) {
            top = steps[i].scrollTop
          }
        }

        this.props.onStartAsShopLogin({
          type: 'start',
          id: this.state.item.Id,
          scrollOffset: top,
          step: this.props.step
        })
        return false
      }
    }

    let { item } = this.state
    let data = {
      Orders: [
        {
          OrderId: item.Id,
          WarrantyCode: null,
          PaintThickness: null
        }
      ],
      UserIds: [],
      WorkOnAll: this.state.stopOtherOrders.WorkOnAll,
      CheckOnly: false,
      ConfirmStart: confirmStart
    }

    // Ensure only one request is sent (protects against double+ clicks)
    if (this.startOrderCount++ === 0) {
      this.props.startOrder(data).then((res) => {
        this.startOrderCount = 0

        if (res.data.StopOtherOrders === true) {
          this.props.triggerPopup(true)
          this.setState({
            stopOtherOrders: {
              ...this.state.stopOtherOrders,
              open: true,
              WorkOnAll: null
            }
          })
        } else if (res.data.length > 0 && res.data.some(x => x.FrontendAction.Action > 0)) {
          // Handle additional actions directed by backend.
          // const NONE = 0
          const CONFIRM_START = 1
          // const GOTO_WORKCARD = 2
          let confirmStart = res.data.some(x => x.FrontendAction.Action === CONFIRM_START)
          if (confirmStart) {
            this.onConfirmStart = () => {
              this.onConfirmStart = null
              this.startOrder(true)
            }
            this.setState({ confirmStart: { open: confirmStart } })
            return
          }
        } else if (res.data.length > 0 && (res.data.some(x => x.QualityCheck.OrderId > 0) || this.stepHasComments(res.data))) {
          this.props.triggerPopup(true)
          this.setState({
            quality: {
              open: true,
              data: {
                res: res.data,
                WorkOnAll: this.state.stopOtherOrders.WorkOnAll,
                UserIds: []
              },
              move: false
            }
          })
        }
        // else {
        // window.toastr.success(translation('13518'), translation('13424'))
        this.startOrderSuccess(res.data[0])
        // }
      }, () => {
        this.startOrderCount = 0
        window.toastr.error(translation('1923'), translation('216'))
      })
    }
  }

  startOrderSuccess (data) {
    this.props.triggerPopup(false)
    this.setState({
      stopOtherOrders: {
        ...this.state.stopOtherOrders,
        WorkOnAll: null
      }
    })

    let item = { ...this.state.item }
    item.IsStarted = true
    item.IsCurrentUserWorking = true
    item.PreviouslyStarted = true
    this.setState({
      item: item
    })
    if (typeof this.props.startOrderSuccess !== 'undefined') {
      this.props.startOrderSuccess(item)
    }
  }

  stopOrder () {
    if (hasAccess([5, 7], this.props.auth.user.UserType)) {
      if (typeof this.props.onStartAsShopLogin !== 'undefined') {
        this.props.onStartAsShopLogin({
          type: 'stop',
          id: this.state.item.Id
        })
        return false
      }
    }

    let { item } = this.state
    let data = {
      OrderId: item.Id,
      UserId: 0,
      StopAll: this.state.stopOrders.StopAll
    }

    this.props.stopOrder(data).then((res) => {
      if (res.data.StopAll === true) {
        this.props.triggerPopup(true)
        this.setState({
          stopOrders: {
            ...this.state.stopOrders,
            open: true,
            StopAll: null
          }
        })
      } else {
        let item = res.data
        this.setState({
          item: item
        })
        clearTimeout(this.updateTime)

        // let message = this.state.stopOrders.StopAll === true ? translation('12340') : translation('15042')
        // window.toastr.success(message, translation('13424'))

        this.setState({
          stopOrders: {
            ...this.state.stopOrders,
            StopAll: null
          }
        })
      }
    }, () => {
      let message = this.state.stopOrders.StopAll === true ? translation('12342') : translation('12343')
      window.toastr.error(message, translation('216'))
    })
  }

  closeQualityModal () {
    this.props.triggerPopup(false)
    this.setState({
      quality: {
        open: false,
        data: {}
      }
    })
  }

  setStopped () {
    this.setState({
      stopped: {
        ...this.state.stopped, open: true
      }
    })
    document.addEventListener('click', this.togglePortal, false)
  }
  modalTitle (item) {
    if (typeof item === 'undefined') item = this.state.item
    if (item === undefined) return null
    let title = ''
    // Model
    if (item.Model) title += item.Model
    // RegNumber
    if (item.RegNumber) {
      if (item.Model) title += ', '
      title += item.RegNumber
    }
    // Title empty
    if (title === '') title += item.Id || item.OrderId
    if (item.Color !== '' && item.Color !== null && typeof item.Color !== 'undefined') title += ', ' + item.Color
    return title
  }

  renderTransportIcon () {
    let classes = 'hasTextInBubble'
    let { item } = this.state

    if (this.props.auth.departmentType === 1) {
      if (item.BodyShopTransport === null || item.BodyShopTransport === 0) {
        return <div className='icon' />
      }
    } else {
      if (item.Transport === null || item.Transport === 0) return <div className='icon' />
    }
    let isshop = hasAccess([3, 5, 7], this.props.auth.user.UserType)
    let showDifferentImageVar = false
    let transportImage = 'Can-drive-black.svg'
    let showDifferentImage = 'Can-drive-different-delivery-black.svg'
    let showBubbleText = translation('2328')
    if (this.props.auth.departmentType === 1) {
      if (item.BodyShopTransport === 3) {
        transportImage = 'Transport-black.svg'
        showDifferentImage = 'Transport-different-delivery-black.svg'
        showBubbleText = translation('2329')
      }

      if (item.IsStarted) {
        transportImage = transportImage.replace('-black.svg', '-white.svg')
        showDifferentImage = showDifferentImage.replace('-black.svg', '-white.svg')
      }

      if (item.BodyShopTransport === 2) {
        transportImage = 'loosepart_black.svg'
        showDifferentImage = 'loosepart_black_redcircle.svg'
        showBubbleText = translation('351')
      }
    } else {
      if (item.Transport === 3) {
        transportImage = 'Transport-black.svg'
        showDifferentImage = 'Transport-different-delivery-black.svg'
        showBubbleText = translation('2329')
      }

      if (item.IsStarted) {
        transportImage = transportImage.replace('-black.svg', '-white.svg')
        showDifferentImage = showDifferentImage.replace('-black.svg', '-white.svg')
      }

      if (item.Transport === 2) {
        transportImage = 'loosepart_black.svg'
        showDifferentImage = 'loosepart_black_redcircle.svg'
        showBubbleText = translation('351')
      }
    }

    if (item.IsStarted) {
      transportImage = transportImage.replace('_black', '_black_white')
      showDifferentImage = showDifferentImage.replace('_black', '_black_white')
    }

    if (this.props.auth.departmentType > 0) {
      // Check pickup location
      if ((item.BodyShopPickupAltLocationId !== 0 || item.BodyShopDeliveryAltLocationId !== 0) && item.StepId === 1) {
        showDifferentImageVar = true
        showBubbleText = translation('13418')
      }

      if ((item.BodyShopPickupAltLocationId === 0 && item.HasBodyShopPickupAltLocation === true) && item.StepId === 1) {
        showDifferentImageVar = true
        showBubbleText = translation('13418')
      }

      if (item.BodyShopDeliveryAltLocationId !== 0 && item.StepId > 1 && !item.StepId === 8) {
        showDifferentImageVar = true
        showBubbleText = translation('13419')
      }

      if ((item.BodyShopDeliveryAltLocationId === 0 && item.HasBodyShopDeliveryAltLocation === true) && item.StepId === 1) {
        showDifferentImageVar = true
        showBubbleText = translation('13419')
      }

      if (item.BodyShopDeliveryAltLocationId === 0 && item.HasBodyShopDeliveryAltLocation === true && item.StepId > 1 && !item.StepId === 8) {
        showDifferentImageVar = true
        showBubbleText = translation('13419')
      }
    } else {
      // Check pickup location
      if ((item.PickupAltLocationId !== 0 || item.DeliveryAltLocationId !== 0) && item.StepId === 1) {
        showDifferentImageVar = true
      }
      if (item.DeliveryAltLocationId !== 0 && item.StepId > 1 && !item.StepId === 8) {
        showDifferentImageVar = true
      }
    }
    if (isshop && (item.IsReferredIn || item.IsReferredOut)) {
      showDifferentImageVar = true
      // showBubbleText = ''
    }
    // Returns
    if (showDifferentImageVar) {
      if (this.state.isIExplorer || this.state.isFireFox) {
        classes += ' hasTextInBubbleIE'
      } else if (this.state.isEdge) {
        classes += ' hasTextInBubbleEdge'
      }
      if (this.state.isTouch) {
        showBubbleText = ''
      }
      return (
        <div className={classes}>
          <div className='hint--right' aria-label={showBubbleText}>
            <img src={'/images/svgs/transport/' + showDifferentImage} className='icon hasCursor' />
            <span>!</span>
          </div>
        </div>
      )
    }
    if (this.state.isTouch) {
      classes = ''
      showBubbleText = ''
    }
    return (
      <div className='hint--right' aria-label={showBubbleText}>
        <img src={'/images/svgs/transport/' + transportImage} className='icon hasCursor' />
      </div>
    )

    /* let { item } = this.state
    let transportImage = 'Can-drive-black.svg'
    let showBubbleText = translation('154')
    // let mouseOverString = '154'
    if (item.Transport === 3) {
      transportImage = 'Transport.svg'
      showBubbleText = translation('26')
      // mouseOverString = '26'
      if (item.IsStarted) transportImage = transportImage.replace('.svg', '-white.svg')
    }
    if (item.Transport === 2) {
      transportImage = 'loosepart_black.svg'
      showBubbleText = translation('351')
    }
    if (item.IsStarted) transportImage = transportImage.replace('-black.svg', '-white.svg')
    return (
      <div className='hint--right' aria-label={showBubbleText}>
        <img src={'/images/svgs/transport/' + transportImage} className='icon' />
      </div>
    ) */
  }

  getEmployeeName () {
    let { item } = this.state

    // Employee
    let employee = ''
    if (item.Employees.length !== 0) {
      employee = item.Employees[0].Initials
      if (item.Employees.length !== 1 && employee !== '') {
        employee += '+'
      }
    }
    // Names popup
    let namesPopup = ''
    if (item.Employees.length !== 0) {
      let names = []
      item.Employees.map((val) => {
        names.push(val.Name)
      })
      var showNames = ''
      if (!this.state.isTouch) showNames = names.join('&#xa;')
      namesPopup = "<span class='hint--bottom' aria-label='" + showNames + "'>" + employee + '</span>'
    }
    if (namesPopup !== '') {
      return (
        <span>
          <div dangerouslySetInnerHTML={{ __html: namesPopup }} />
        </span>
      )
    }
    // Return normal
    return <span className='workers_name'>{employee}</span>
  }

  getCircleImages (item) {
    // let { item } = this.state
    let image = 'Timespent-'
    let colored = (item.ColoredParts < 0) ? 0 : item.ColoredParts
    switch (item.RemainingTimeDelay) {
      case 0:
        if (colored === 0) {
          if (item.IsStarted !== true) {
            image += 'Black-0'
          }
        } else {
          image += 'Green-' + colored
        }
        break
      case 1:
        image += 'Yellow-8'
        break
      case 2:
        let coloredX = (colored < 8) ? colored : 8
        coloredX = (coloredX === 0) ? 8 : coloredX
        image += 'Red-' + coloredX
        break
    }

    let color = (item.IsStarted && image.indexOf('Black-0') === -1) ? '-White' : ''

    return image + color
  }

  renderCircle (opener) {
    let { item } = this.state
    if (typeof item.ColoredParts === 'undefined') {
      return (
        <div className='workers' />
      )
    }
    let image = this.getCircleImages(item)
    if (!hasSubscriptionPermission(this.props.auth, 20)) {
      if (item.IsStarted === true) {
        image = '../Ring-White'
      } else {
        image = '../Ring-Black'
      }
    }
    // let image = this.state.image
    let EmployeeName = this.getEmployeeName()
    let onClick = (item.IsCurrentUserWorking) ? this.stopOrder : this.startOrder
    if (opener !== false) {
      onClick = opener
    }
    return (
      <div className='workers' onClick={onClick} ref={(c) => (this.startStop = c)}>
        <img src={'/images/icons/circle/' + image + '.png'} className='worker__image' />
        {EmployeeName}
      </div>
    )
  }

  /**
   * Start ikon - Hvis man er tildelt
   * Cirkel ikon uden timer - Hvis man ikke er tildelt
   * Cirkel ikon - Hvis ordren har været startet
   * Stop ikon - Hvis ordren er i StepId 1 eller 7
   */
  renderWorkers () {
    let { item } = this.state
    if (item === undefined) return null

    // Stop icon
    const renderStopIcon = () => {
      // if (item.StepId === 7 || this.props.type === '1') {
      // if (item.StepId !== 7 && item.StepId !== 1) {
      const renderActionOpener = (opener) => {
        return this.renderCircle(opener)
        /*
        return (
          <div className='workers' onClick={opener}>
            <img src={'/images/icons/Stop-White.png'} />
          </div>
        )
        */
      }
      const renderActionMenu = () => {
        return (
          <div className='poppedup'>
            <a data-action='stop'><img src='/images/icons/pause-sign-32x32.png' />{translation('440')}</a>
            <a data-action='complete'><img src='/images/icons/Chekmark-Black-32.png' />{translation('1732')}</a>
          </div>
        )
      }
      const handleClick = (el) => {
        switch (el.dataset.action) {
          case 'stop':
            this.stopOrder()
            break
          case 'complete':
            this.props.MoveOrders({ OrderIds: [this.props.item.Id], UserId: 0, StepFrom: item.StepId, StepTo: null  /*  (item.StepId + 1) */, Comment: '', FilterSettings: {} })
            break
        }
      }
      const className = () => { return 'action__menu close__menu' }
      // return null

      return (
        <ActionMenu className={className} step={this.props.step} index={this.props.index} item={this.state.item} handleClick={handleClick} renderActionOpener={renderActionOpener} renderActionMenu={renderActionMenu} noAriaLabel />
      )
      // }
      /*
      return (
        <div className='workers' onClick={this.stopOrder}>
          <img src={'/images/icons/Stop-White.png'} />
        </div>
      )
      */
    }

    const renderReferredApprove = () => {
      let { item } = this.state
      if (this.props.item.NeedReferredApprove) {
        if (item.ReferredApproved) return null
        var ariaLabel = ''
        if (!this.state.isTouch) ariaLabel = translation('751')
        return (
          <div className='icon hint--top hasBackground workers' aria-label={ariaLabel} onClick={this.openReferenceApprove}>
            <img src={'/images/svgs/New-order-red-referred.svg'} />
          </div>
        )
      }
    }

    // Icon with names in
    const renderIconWithNames = () => {
      if (item.IsStarted) {
        return (
          <div className='workers' onClick={this.startOrder} ref={(c) => (this.startStop = c)}>
            <img src={'/images/icons/Ring-White.png'} />
            {this.getEmployeeName()}
          </div>
        )
      } else {
        return (
          <div className='workers' onClick={this.startOrder} ref={(c) => (this.startStop = c)}>
            <img src={'/images/icons/Ring-Black.png'} />
            {this.getEmployeeName()}
          </div>
        )
      }
    }
    if (item.IsStopped) {
      if (!hasSubscriptionPermission(this.props.auth, 20)) {
        return (
          <div className='workers noCursor'>
            <img src='/images/icons/Stop-31.png' />
          </div>
        )
      }
      return (
        <div className='workers' onClick={this.setStopped} ref={(c) => (this.startStop = c)}>
          <img src={'/images/icons/Stop-31.png'} />
        </div>
      )
    }

    if (!hasSubscriptionPermission(this.props.auth, 20)) {
      return (
        <div className='workers noCursor'>
          <img src={'/images/icons/Ring-Black.png'} />
          {this.getEmployeeName()}
        </div>
      )
    }

    if (this.props.item.NeedReferredApprove) {
      return renderReferredApprove()
    }

    // New type
    // if (this.props.type === '1') {
    if (this.props.type !== '111') {
      if (item.IsCurrentUserWorking) {
        return renderStopIcon()
      }
    }

    // Step 1 & 7
    if (!hasSubscriptionPermission(this.props.auth, 20) || item.StepId === 1 || item.StepId === 7) {
      if (item.IsCurrentUserWorking) {
        return renderStopIcon()
      }
      if (item.IsCurrentUserAssigned) {
        return (
          <div className='workers' onClick={this.startOrder} ref={(c) => (this.startStop = c)}>
            <img src={'/images/icons/Start-Black.png'} />
          </div>
        )
      } else {
        return renderIconWithNames()
      }
    }

    // Order has been started
    if (item.PreviouslyStarted) {
      return this.renderCircle(false)
    }

    // User is assigned
    if (item.IsCurrentUserAssigned) {
      return (
        <div className='workers' onClick={this.startOrder} ref={(c) => (this.startStop = c)}>
          <img src={'/images/icons/Start-Black.png'} />
        </div>
      )
    }

    // Order has not been started
    return renderIconWithNames()
  }

  canClick (type, id, e) {
    if (hasAccess([5, 7], this.props.auth.user.UserType)) {
      if (typeof this.props.onStartAsShopLogin !== 'undefined') {
        e.preventDefault()
        e.stopPropagation()
        e.nativeEvent.stopImmediatePropagation()
        this.props.onStartAsShopLogin({
          type: type,
          id: (id === 0) ? this.state.item.Id : id
        })
        return false
      }
    }
  }

  middleSectionBorder (existingClass) {
    if (!hasSubscriptionPermission(this.props.auth, 20, 0)) {
      existingClass += ' hasBorder'
      return existingClass
    }
    if (hasSubscriptionPermission(this.props.auth, 20) && this.state.item.InspectionStepsCompleted === 0) {
      existingClass += ' hasBorder Red'
    }
    if (hasSubscriptionPermission(this.props.auth, 20) && this.state.item.InspectionStepsCompleted !== 0 && this.state.item.InspectionStepsCompleted !== this.state.item.InspectionStepsTotal) {
      existingClass += ' hasBorder Yellow'
    } else {
      existingClass += ' hasBorder'
    }
    return existingClass
  }

  renderInspectionStep () {
    let { item } = this.state
    let backgroundClass = 'fullSize inspection'
    if (!hasSubscriptionPermission(this.props.auth, 10, 0)) return (<span className={backgroundClass} />)
    // Dette er hvad vi viser, hvis vi er et pladeværksted/karosseri
    // if (this.props.auth.departmentType === 1) {
    //   return (
    //     <div className={backgroundClass} />
    //   )
    // }
    backgroundClass = this.middleSectionBorder(backgroundClass)
    return (
      <span className={backgroundClass}>
        <div onClick={this.canClick.bind(this, 'inspection', 0)}>
          {item.InspectionStepsCompleted} / {item.InspectionStepsTotal}
        </div>
      </span>
    )
  }

  renderDisplayTime () {
    let { item } = this.state

    if (item.DisplayedTimePrt1 === '' && item.DisplayedTimePrt2 === '') return null
    let className = 'fullSize displayTime'
    if (hasSubscriptionPermission(this.props.auth, 20)) {
      switch (item.Delay) {
        case 1:
          className += ' hasBorder Yellow'
          break
        case 2:
          className += ' hasBorder Red'
          break
        default:
          className += ' hasBorder'
      }
    } else {
      className += ' hasBorder'
    }
    if (!hasSubscriptionPermission(this.props.auth, 10, 0)) {
      className = 'fullSize displayTime'
    }
    return (
      <span className={className + ' borderBottom'}>
        {item.DisplayedTimePrt1}&nbsp;&nbsp;&nbsp;{item.DisplayedTimePrt2}
      </span>
    )
  }

  renderDisplayTimeNew () {
    let { item } = this.state

    if (item.BodyShopProductionTime === '' && item.ProductionTime === '') {
      return null
    } else {
      let className = 'fullSize displayTime'
      if (hasSubscriptionPermission(this.props.auth, 20)) {
        switch (item.Delay) {
          case 1:
            className += ' hasBorder Yellow'
            break
          case 2:
            className += ' hasBorder Red'
            break
          default:
            className += ' hasBorder'
        }
      } else {
        className += ' hasBorder'
      }

      return (
        <span className={className + ' borderBottom'}>
          {item.DisplayedTimePrt1}&nbsp;&nbsp;&nbsp;{item.DisplayedTimePrt2}
        </span>
      )
    }
  }

  renderNotes () {
    let icon
    let imgSrc = ''
    let classes = 'icon hasTextInBubble'

    var ariaLabel = ''

    if (!this.state.item.HasNotes || !hasSubscriptionPermission(this.props.auth, 0)) {
      return <div className='icon' />
    }

    // if order has unread notes
    if (this.state.item.UnreadNotes !== 0) {
      imgSrc = '/images/svgs/comment/comment-red-circle.svg'

      if (this.state.item.IsStarted) imgSrc = imgSrc.replace('.svg', '-white.svg')

      if (this.state.isIExplorer) {
        classes += ' hasTextInBubbleIE'
      } else if (this.state.isEdge) {
        classes += ' hasTextInBubbleEdge'
      } else if (this.state.isFireFox) {
        classes += ' hasTextInBubbleFireFox'
      }

      if (!this.state.isTouch) {
        ariaLabel = translation('2339')
      }
      icon = (
        <span className={classes}>
          <div className='hint--right' aria-label={ariaLabel}>
            <img src={imgSrc} className='icon' />
            <span>{this.state.item.UnreadNotes}</span>
          </div>
        </span>
      )
    } else {
      // Default
      imgSrc = '/images/svgs/comment/comment-new.svg'
      if (this.state.item.IsStarted) imgSrc = imgSrc.replace('.svg', '-white.svg')

      if (!this.state.isTouch) {
        ariaLabel = translation('149')
      }
      icon = (
        <div className='hint--right' aria-label={ariaLabel}>
          <img src={imgSrc} className='icon' />
        </div>
      )
    }
    return icon
  }

  renderColor () {
    let image = null
    let openImg = null
    let showBubbleText = ''
    if (this.state.item.ColorIsReady) {
      image = 'Color-ok.svg'
      showBubbleText = translation('2075')
    } else if (this.state.item.ColorVariant !== null && this.state.item.ColorVariant !== '') {
      image = 'color-variation.svg'
      showBubbleText = translation('13388')
    } else if (this.state.item.ColorCode !== null && this.state.item.ColorCode !== '') {
      image = 'Color_code.svg'
      showBubbleText = translation('79')
    } else if (this.state.item.Color !== null && this.state.item.Color !== '') {
      image = 'Color.svg'
      showBubbleText = translation('179')
    }
    if (this.state.item.IsStarted && image !== null) {
      image = image.replace('.svg', '-white.svg')
    }
    if (this.state.isTouch) showBubbleText = ''
    openImg = <div className='hint--top' aria-label={showBubbleText}><img src={'/images/svgs/color/' + image} className='icon' /></div>
    if (image === null) openImg = <div className='icon' />
    return openImg
  }

  renderTaksering () {
    let backgroundClass = this.middleSectionBorder('fullSize Taksering')

    // Dette her viser vi i tilfælde af isEvaluation = false og vi der pladeværksted/karosseri
    if (!this.state.item.isEvaluation && this.props.auth.departmentType === 1) {
      return (
        <div className={'fullSize Taksering'}>
          <div className='icon' />
        </div>
      )
    }

    return (
      <div className={backgroundClass}>
        <Taksering item={this.state.item} type='workscreen' />
      </div>
    )
  }

  renderMissingPart () {
    let backgroundClass = this.middleSectionBorder('fullSize missingPart')
    // Dette indhold viser vi i tilfælde af der ikke er en part og vi er pladeværksted/karosseri
    if (!this.state.item.MissingParts && this.props.auth.departmentType === 1) {
      return <div className={'fullSize missingPart'} />
    }
    if (!this.state.item.MissingParts) return <div className={backgroundClass} />

    let text = this.state.item.MissingPartsMessage
    text = text === null ? '' : text
    if (text.length > 50) {
      const breakTextNicely = (text, limit) => {
        var parts = text.split(' ')
        var lines = []
        text = parts[0]
        parts.shift()
        while (parts.length > 0) {
          var newText = `${text} ${parts[0]}`
          if (newText.length > limit) {
            lines.push(`${text}\n`)
            text = parts[0]
          } else {
            text = newText
          }
          parts.shift()
        }
        lines.push(text)
        return lines.join('')
      }
      text = breakTextNicely(text, 50)
    }

    let message = translation('2322')
    if (text.length > 0) {
      message = message + ':\n' + text
    }

    let icon = '/images/svgs/missing-parts/missing-parts.svg'
    if (this.state.item.IsStarted) icon = icon.replace('.svg', '-white.svg')
    if (this.state.isTouch) message = ''
    return (
      <div className={backgroundClass}>
        <span className='icon'>
          <div className='hint--left' aria-label={message}>
            <img src={icon} style={{ width: 25, height: 25, marginTop: -3 }} />
          </div>
        </span>
      </div>
    )
  }
  renderRentalCar (item) {
    if (item.HasCarRental === true || item.HasRequestedCarRental === true) {
      // return if CarRentalAssignments only contains alternative.
      if (item.CarRentalAssignments.length > 0 && !item.HasCarRentalNotAlternative) return <div className='icon' />

      const hasNoCarSelected = item.HasRequestedCarRental && item.CarRentalAssignments.length === 0

      // if (item.CarRentalId !== 0) {
      let icon = '/images/svgs/ordrer/lend-cirkel.svg'
      let number = 0
      if (item.CarRentalAssignments.length > 0) {
        number = item.CarRentalAssignments[0].CarNumber
      }
      let whatClass = 'rentCarAmount'

      if (item.IsStarted === true) {
        icon = '/images/svgs/ordrer/lend-cirkel-white.svg'
        whatClass = 'rentCarAmount rentCarAmountActive'
        icon = '/images/svgs/ordrer/lend-cirkel-white.svg'
        switch (item.CarRentalColliderType) {
          case 0:
            icon = '/images/svgs/ordrer/lend-cirkel-white.svg'
            break
          case 1:
            // icon = '/images/svgs/ordrer/lend-yellowcircle-white.svg'
            break
          case 2:
            // icon = '/images/svgs/ordrer/lend-redcircle-white.svg'
            break
        }
      } else {
        icon = '/images/svgs/ordrer/lend-cirkel.svg'
        switch (item.CarRentalColliderType) {
          case 0:
            icon = '/images/svgs/ordrer/lend-cirkel.svg'
            break
          case 1:
            icon = '/images/svgs/ordrer/lend-yellowcircle.svg'
            break
          case 2:
            icon = '/images/svgs/ordrer/lend-redcircle.svg'
            break
        }

        if (hasNoCarSelected) {
          icon = '/images/svgs/ordrer/lend-redcircle.svg'
        }
      }

      if (number > 9) {
        whatClass += ' rentCarAmountDoubleDigits'
      }

      if (item.HasCarRental && !item.CurrentShopCanAssignRentalCar) {  // Hide rental car number for car from other company.
        number = ''
        icon = '/images/svgs/ordrer/lend.svg'
      }

      let hoverLines = []
      let useClick = true
      let useHover = true
      let carRentalAssignments = item.CarRentalAssignments
      if (carRentalAssignments.length > 0) {
        carRentalAssignments.forEach((elem, i) => {
          hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{elem.Identity}</p>))
          hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{renderFullDate(elem.Start, true)}</p>))
          hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{renderFullDate(elem.End, true)}</p>))
          if (i < carRentalAssignments.length - 1) {
            hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()} />))
          }
        })
      } else {
        hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{renderFullDate(item.BodyShopPickupTime, true)}</p>))
        hoverLines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{renderFullDate(item.BodyShopDeliveryTime, true)}</p>))
      }

      return (
        <HoverPopup UseClick={useClick} UseHover={useHover} orderId={item.Id} getVerticalScrollOffset={this.props.getVerticalScrollOffset} getHorizontalScrollOffset={this.props.getHorizontalScrollOffset} scrollColumn={this.props.step} PopupContent={hoverLines}>
          <div>
            <span className='icon'>
              <img src={icon} style={{ width: 25, height: 25, marginTop: -3 }} />
            </span>
            {!hasNoCarSelected && <font className={whatClass}>{number}</font>}
          </div>
        </HoverPopup>
      )
      // }
    } else {
      return <div className='icon' />
    }
  }

  renderApprovedReportRecievedIcon (item) {
    if (!item.Report) {
      return this.renderSpacerIcon()
    }

    let image = ''
    let mouseText = ''
    let report = item.Report
    let chainUsesDBS = this.props.auth.permissions.ChainAssessmentSystem === 2
    let bookingStopped = this.props.item.IsAgreementForsiCreated && !this.props.item.IsEvaluation
    let evaluationStopped = this.props.item.IsEvaluation && !this.props.item.IsEvaluated && this.props.item.CustomerWPEvaluationRequired && this.props.item.IsAgreementOrder
    let hasUserAccess = hasAccess([4], this.props.auth.user.UserType)
    let isMainReportLoadedIcon = false
    let { IsAssessmentOk } = this.props.item

    if (report !== null && report.ReportVersionNr === 0 && report.IsApproved) {
      image = OrderAssessmentIcons.Main_Report_Loaded
      mouseText = translation('13023')
      isMainReportLoadedIcon = true
    }
    if (hasUserAccess && item.LastUpdatedType === 1) {
      image = OrderAssessmentIcons.Charged_Later_Recieved
      mouseText = translation('1019')
      isMainReportLoadedIcon = false
    }
    if (!hasUserAccess && item.LastUpdatedType === 1 && this.props.auth.departmentType === 1) {
      image = OrderAssessmentIcons.Charged_Later_Recieved
      mouseText = translation('1019')
      isMainReportLoadedIcon = false
    }
    if (!hasUserAccess && item.LastUpdatedType === 1 && this.props.auth.departmentType !== 1) {
      image = OrderAssessmentIcons.Charged_Later_Sent
      mouseText = translation('13528')
      isMainReportLoadedIcon = false
    }
    if (report !== null && !chainUsesDBS && report.IsApproved && report.ReportVersionNr > 0) {
      mouseText = translation('937')
      isMainReportLoadedIcon = false
      if (IsAssessmentOk || hasUserAccess) {
        image = OrderAssessmentIcons.Update_Approved
        if (!hasAccess([4], this.props.auth.user.UserType) && this.props.auth.departmentType !== 1) {
          mouseText = translation('13530')
        }
      } else {
        image = OrderAssessmentIcons.Main_Report_Update_Not_Approved
        mouseText = translation('13531')
      }
    }
    if (item.ForsiReportId) {
      if ((!this.props.item.IsEvaluationRejected || this.props.item.IsEvaluationRejected && !isMainReportLoadedIcon) && !bookingStopped && !evaluationStopped) {
        if (!hasUserAccess && this.props.auth.departmentType !== 1) {
          if (IsAssessmentOk === true) {
            image = OrderAssessmentIcons.Main_Report_Approved
            mouseText = translation('13513')
          } else {
            image = OrderAssessmentIcons.Main_Report_Not_Approved
            mouseText = translation('13526')
          }
          mouseText = mouseText.replace('- ', '-\n')
        }
      }
    }

    if (image === '') {
      return this.renderSpacerIcon()
    }

    if (item.IsStarted) {
      if (image && image.fileName) {
        image = { fileName: image.fileName.replace('.svg', '-white.svg') }
      }
    }

    return <div className='hint--right' aria-label={mouseText}>
      <Icon icon={image} className='icon' style={{ marginTop: -3 }} />
    </div>
  }

  renderSpacerIcon () {
    return <div className='icon' />
  }

  renderRekvNumber (item) {
    let MyRekvNumber = ''

    if (item.BodyShopRekvNumber !== null && item.BodyShopRekvNumber !== '' && item.BodyShopRekvNumber !== 0) {
      MyRekvNumber = item.BodyShopRekvNumber
    }

    if (item.RekvNumber !== null && item.RekvNumber !== '' && item.RekvNumber !== 0 && this.props.auth.departmentType === 0) {
      MyRekvNumber = item.RekvNumber
    }

    if (MyRekvNumber !== '') {
      return (
        <div className='fullSize displayTime RekvNumber'>
          {'# ' + MyRekvNumber}
        </div>
      )
    } else {
      return (
        <div className='fullSize displayTime RekvNumber'>
          &nbsp;
        </div>
      )
    }
  }

  renderNewItemLine (item) {
    if (this.props.auth.departmentType !== 0) {
      // used for custom ipad style bug fix
      let isiPadPro = isTouchDevice() && /MacIntel/.test(navigator.platform)
      let customIpad = ''
      if (isiPadPro) {
        customIpad = ' customIpad-style'
      }

      return (
        <div className={'lower' + customIpad}>
          <div onClick={this.goToWorkcard} className='lower_icons' style={{ display: 'inline-block' }}>
            <Link to={hasSubscriptionPermission(this.props.auth, 0, 2) || hasSubscriptionPermission(this.props.auth, 0, 3) ? '/orders/' + item.Id : ''} unselectable='on' onClick={this.canClick.bind(this, 'workcard', 0)}>
              {this.renderRentalCar(item)}
              {this.renderApprovedReportRecievedIcon(item)}
              {this.renderSpacerIcon()}
            </Link>
          </div>
          <div className='divider body' />
          <div onClick={this.goToWorkcard} className={'borderBottom'}>
            {this.renderRekvNumber(item)}
          </div>
          <div className='divider body' />
          {this.renderPaintBodyStatus(item)}
        </div>
      )
    }
  }

  renderPaintBodyStatus (item) {
    if (item.Id === 944638 || item.Id === 944656 || item.Id === 944658) {
      // console.log(item)
    }

    let paintLit = false
    let bodyLit = false

    let paintBooked = false
    let bodyBooked = false

    let paintOrdered = false
    let bodyOrdered = false

    let paintNotOrdered = false
    let bodyNotOrdered = false

    let paintTextItems = []
    let bodyTextItems = []
    let overallTextItems = []

    // Order shown as PaintShop, BodyShop or CombinedShop
    if (item.OrderDepartment === 0 || item.OrderDepartment === 1 || item.OrderDepartment === 2) {
      paintLit = item.IsPaintOrder
      paintBooked = !item.PaintIsDraft
      if (hasSubscriptionPermission(this.props.auth, 10)) {
        paintOrdered = item.HasSpareParts && item.PaintSparePartStatusSum === 8
        paintNotOrdered = item.HasSpareParts && item.PaintSparePartStatusSum === 1
      }
    }

    // Order shown as BodyShop or CombinedShop
    if (item.OrderDepartment === 1 || item.OrderDepartment === 2) {
      bodyLit = item.IsBodyShopOrder
      bodyBooked = !item.BodyShopIsDraft
      if (hasSubscriptionPermission(this.props.auth, 10)) {
        bodyOrdered = item.HasSpareParts && item.BodySparePartStatusSum === 8
        bodyNotOrdered = item.HasSpareParts && item.BodySparePartStatusSum === 1
      }
    }

    let image = 'show-work'
    let imgPath = '/images/svgs/orderlist/'

    // Check for paint/body work
    if (paintLit) {
      image += '_paint-lit'
      paintTextItems.push(translation('14829'))
    }
    if (bodyLit) {
      image += '_body-lit'
      bodyTextItems.push(translation('14830'))
    }

    if (paintLit && bodyLit) {
      overallTextItems.push(translation('14867'))
    }

    // Check for paint/body booked
    if (paintLit && !paintBooked) {
      image += '_paint-red'
      paintTextItems.push(translation('13045'))
    } else if (paintNotOrdered && !paintOrdered) {
      image += '_paint-red'
    } else if (hasSubscriptionPermission(this.props.auth, 10) && paintNotOrdered) {
      image += '_paint-red'
      // Check for paint/body spare parts ordered
    } else if (paintOrdered && !paintNotOrdered) {
      image += '_paint-yellow'
    }

    if (bodyLit && !bodyBooked) {
      image += '_body-red'
      bodyTextItems.push(translation('13046'))
    } else if (bodyLit && bodyBooked && bodyNotOrdered && !bodyOrdered) {
      image += '_body-red'
    } else if (bodyLit && hasSubscriptionPermission(this.props.auth, 10) && bodyNotOrdered) {
      image += '_body-red'
    }

    if (bodyLit && bodyBooked && bodyOrdered && !bodyNotOrdered) {
      image += '_body-yellow'
    }

    if (item.HasSpareParts === true && item.BodySparePartStatusSum !== 0 && hasSubscriptionPermission(this.props.auth, 10)) {
      // Body spare parts not ordered
      if (item.BodySparePartStatusSum === 1) {
        bodyTextItems.push(translation('13048'))
      }

      // Body spare parts not received
      if (item.BodySparePartStatusSum === 8) {
        bodyTextItems.push(translation('13050'))
      }

      // Body spare parts received
      if (item.BodySparePartStatusSum === 16) {
        bodyTextItems.push(translation('14870'))
      }
    }

    if (item.HasSpareParts === true && item.PaintSparePartStatusSum !== 0 && hasSubscriptionPermission(this.props.auth, 10)) {
      // Paint spare parts not ordered
      if (item.PaintSparePartStatusSum === 1) {
        if (bodyLit) {
          paintTextItems.push(translation('13047'))
        } else {
          paintTextItems.push(translation('638'))
        }
      }

      // Paint spare parts not received
      if (item.PaintSparePartStatusSum === 8) {
        if (bodyLit) {
          paintTextItems.push(translation('13049'))
        } else {
          paintTextItems.push(translation('639'))
        }
      }

      // Paint spare parts received
      if (item.PaintSparePartStatusSum === 16) {
        if (bodyLit) {
          paintTextItems.push(translation('14872'))
        } else {
          paintTextItems.push(translation('640'))
        }
      }
    }

    /*

    if (paintNotOrdered && !paintOrdered) {
      paintTextItems.push(translation('13047'))
    }
    if (bodyNotOrdered && !bodyOrdered) {
      bodyTextItems.push(translation('13048'))
    }
    if (paintOrdered && !paintNotOrdered) {
      paintTextItems.push(translation('13049'))
    }
    if (bodyOrdered && !bodyNotOrdered) {
      bodyTextItems.push(translation('13050'))
    }

    */

    image += '.svg'

    let lines = []
    const hoverHoverTextLines = (val, key) => {
      if (key === 0) {
        if (lines.length > 0) {
          lines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()} />))
        }
      }
      lines.push((<p key={item.Id + '_' + Math.random() + '_' + Math.random()}>{val}</p>))
    }

    const addOverallText = (val, key) => {
      if (key !== 0) {
        overallTextItems.push(val)
      }
    }

    if (paintLit && bodyLit) {
      paintTextItems.map(addOverallText)
      bodyTextItems.map(addOverallText)

      overallTextItems.map(hoverHoverTextLines)
    } else {
      paintTextItems.map(hoverHoverTextLines)
      bodyTextItems.map(hoverHoverTextLines)
    }
    let useClick = true
    let useHover = true

    if (lines.length === 0) {
      lines = translation('14856')
    }

    return (
      <span className='fullSize orderStatus'>
        <div>
          <HoverPopup UseClick={useClick} UseHover={useHover} orderId={item.Id} getVerticalScrollOffset={this.props.getVerticalScrollOffset} getHorizontalScrollOffset={this.props.getHorizontalScrollOffset} scrollColumn={this.props.step} PopupContent={lines} >
            <img src={imgPath + image} className='PaintBodyStatus' />
          </HoverPopup>
        </div>
      </span>
    )
  }

  render () {
    let { item } = this.state
    if (typeof item === 'undefined') return null
    // if (item.NeedReferredApprove) return null
    // Active class
    let className = ''
    let whatdots = ''
    if (item.IsStarted) {
      className = 'active'
      whatdots = '/images/svgs/menuicons/Menu-dots-white.svg'
    } else {
      whatdots = '/images/svgs/menuicons/Menu_dots-Black.svg'
    }

    const renderLinked = () => {
      if (!hasSubscriptionPermission(this.props.auth, 30)) return null
      if (item.LinkedOrders.length !== 0) {
        var ariaLabel = ''
        if (!this.state.isTouch) ariaLabel = translation('13525')
        if (item.IsStarted) {
          return (
            <div className='linkedIcon hint--bottom-left' aria-label={ariaLabel} onClick={this.startOrder} >
              <img src='/images/svgs/workscreen/link-order-white.svg' style={{ width: 15, height: 15 }} />
            </div>
          )
        } else {
          return (
            <div className='linkedIcon hint--bottom-left' aria-label={ariaLabel} onClick={this.startOrder} >
              <img src='/images/svgs/workscreen/link-order.svg' style={{ width: 15, height: 15 }} />
            </div>
          )
        }
      }
    }
    var stepName = translation(enumtranslate('PaintShopOrderSteps', item.StepId))
    // Render name
    const renderName = () => {
      if (item.LinkedOrders.length !== 0 && hasSubscriptionPermission(this.props.auth, 30)) {
        const toggleSelector = (e) => {
          e.preventDefault()
          if (!this.state.openlinkedselector) {
            this.setState({
              openlinkedselector: true
            })
            window.setTimeout(() => {
              window.removeEventListener('click', toggleSelector)
              window.addEventListener('click', toggleSelector)
            }, 10)
          } else {
            window.removeEventListener('click', toggleSelector)
            window.setTimeout(() => {
              this.setState({
                openlinkedselector: false
              })
            }, 10)
          }
        }
        var title = this.modalTitle()
        var modalTitle = ''
        if (!this.state.isTouch) modalTitle = title
        const renderLinked = (v, k) => {
          var title = this.modalTitle(v)
          if (this.state.isTouch) {
            return (
              <Link to={'/orders/' + v.Id} onClick={this.canClick.bind(this, 'workcard', v.Id)}>
                {k + 2}. {title}
              </Link>
            )
          }
          return (
            <HoverExtent router={this.props.router} id={v.Id} item={v} key={k} >
              <Link to={'/orders/' + v.Id} onClick={this.canClick.bind(this, 'workcard', v.Id)}>
                {k + 2}. {title}
              </Link>
            </HoverExtent>
          )
        }

        if (!this.state.isTouch) modalTitle = title
        return (
          <div className='name linkedSelectorWrapper'>
            <Link to={'/orders/' + item.Id} unselectable='on' onClick={toggleSelector.bind(this)} >
              <div className='hint--bottom-right' aria-label={modalTitle}><strong>{title}</strong></div>
              {this.props.type === '0' && <span>{item.CustomerName}</span>}
              {this.props.type === '1' && <span>{stepName}</span>}
            </Link>
            {this.state.openlinkedselector && (
              <div className='openlinkedselector'>
                {this.state.isTouch && (
                  <Link to={'/orders/' + item.Id}>
                    1. {this.modalTitle()}
                  </Link>
                )}
                {!this.state.isTouch && (
                  <HoverExtent router={this.props.router} id={item.Id} item={item}>
                    <Link to={'/orders/' + item.Id}>
                      1. {this.modalTitle()}
                    </Link>
                  </HoverExtent>)}
                {item.LinkedOrders.map(renderLinked)}
              </div>
            )}
          </div>
        )
      }
      title = this.modalTitle()
      modalTitle = ''
      if (!this.state.isTouch) modalTitle = title
      return (
        <div className='name' onClick={this.goToWorkcard}>
          {this.state.isTouch && (
            <Link to={hasSubscriptionPermission(this.props.auth, 0, 2) || hasSubscriptionPermission(this.props.auth, 0, 3) ? '/orders/' + item.Id : ''} unselectable='on' onClick={this.canClick.bind(this, 'workcard', 0)}>
              <div className=''><strong>{title}</strong></div>
              {this.props.type === '0' && <span>{item.CustomerName}</span>}
              {this.props.type === '1' && <span>{stepName}</span>}
            </Link>
          )}
          {!this.state.isTouch && (
            <HoverExtent router={this.props.router} id={item.Id} item={item}>
              <Link to={hasSubscriptionPermission(this.props.auth, 0, 2) || hasSubscriptionPermission(this.props.auth, 0, 3) ? '/orders/' + item.Id : ''} unselectable='on' onClick={this.canClick.bind(this, 'workcard', 0)}>
                <div className='hint--bottom-right' aria-label={modalTitle}><strong>{title}</strong></div>
                {this.props.type === '0' && <span>{item.CustomerName}</span>}
                {this.props.type === '1' && <span>{stepName}</span>}
              </Link>
            </HoverExtent>)}
        </div>
      )
    }
    let isTouch = this.state.isTouch
    let hasAcc = hasAccess([5, 7], this.props.auth.user.UserType)
    let menuClass = 'action__menu'
    if (isTouch) menuClass += ' actionSwipe'

    const renderCircleActions = () => {
      const renderActionMenuArea = () => {
        if (hasAcc) {
          return (
            <div className={menuClass} onClick={this.canClick.bind(this, 'action', 0)}>
              <span>
                {isTouch ? (
                  <img src={'/images/icons/' + (item.IsStarted ? 'action-swipe-dots-white-22x22.png' : 'action-swipe-dot-22x.png')} />
                ) : (
                  <img src={whatdots} />
                )}
              </span>
            </div>
          )
        } else {
          return <OrderActions router={this.props.router} onOrderMove={this.props.MoveOrders} onOrderMoveSuccess={this.props.onMoveSuccess} open={this.props.openAction} itemType={this.props.type} item={item} type='workscreen' index={this.props.index} step={this.props.step} isStarted={item.IsStarted} />
        }
      }
      return (
        <div>
          {!item.IsDisplayOnly && hasSubscriptionPermission(this.props.auth, 10) && this.renderWorkers()}
          {!item.IsDisplayOnly && renderActionMenuArea()}
        </div>
      )
    }
    const stopMessage = () => {
      let message = translation(13501) + this.props.item.StoppedMessage
      if (this.props.item.StoppedMessage.length === 0) {
        message = message.replace(':', '')
      }
      return message
    }
    var modalTitle = this.modalTitle(this.state.item)
    // Return
    let mouseFix = ''
    if (!hasSubscriptionPermission(this.props.auth, 10, 30)) {
      mouseFix = 'mouseFix'
    }
    // not booked in paintshop
    let popupText = translation(15245)
    // is booked but not finished in paintshop
    if (item.IsPaintOrder && !item.PaintIsDraft && !item.IsArchived) {
      popupText = translation(15268)
    }

    return (
      <div className={'workscreen__item draggable ' + (item.IsDisplayOnly ? 'locked ' : '') + className} data-index={this.props.index}>
        <div className='upper'>
          {this.state.stopped.open && (
            <div className='helpText'>
              <div className='helperTextModal' onClick={this.togglePortal}>
                <img src='/images/icons/close_24-Black.png' />
                {stopMessage()}
              </div>
            </div>
          )}
          {renderName()}
          {renderLinked()}
          <div className='buttons'>
            {this.props.noCircle !== true && renderCircleActions()}
          </div>
        </div>
        <div className='lower'>
          <div onClick={this.goToWorkcard} className='lower_icons' style={{ display: 'inline-block' }}>
            <Link to={hasSubscriptionPermission(this.props.auth, 0, 2) || hasSubscriptionPermission(this.props.auth, 0, 3) ? '/orders/' + item.Id : ''} unselectable='on' onClick={this.canClick.bind(this, 'workcard', 0)}>
              {this.renderTransportIcon()}
              {this.renderNotes()}
              {this.renderColor()}
            </Link>
          </div>
          {this.props.auth.departmentType !== 0 && (
            <div className='divider dividerTop body' />
          )}
          {this.props.auth.departmentType === 0 && (
            <div className='divider' />
          )}
          <div onClick={this.goToInspection} className={'borderBottom ' + mouseFix}>
            {this.renderInspectionStep()}
            {this.renderMissingPart()}
            <div className={'borderBottom ' + mouseFix}>
              {this.renderTaksering()}
            </div>
          </div>
          {this.props.auth.departmentType !== 0 && (
            <div className='divider dividerTop body' />
          )}

          {this.props.auth.departmentType === 0 && (
            <div className='divider' />
          )}
          {this.renderDisplayTimeNew()}
        </div>
        {this.renderNewItemLine(item)}
        {this.state.quality.open && (
          <QualityCheckModal
            router={this.props.router}
            show={this.state.quality.open}
            data={this.state.quality.data}
            name={modalTitle}
            onSuccess={this.startOrderSuccess}
            onClose={this.closeQualityModal}
            move={false} />
        )}
        {this.state.stopOtherOrders.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'stopOtherOrders')}>
            <StopOtherOrders Stop={false} AllOrders={this.AllOrders.bind(this, 'stopOtherOrders')} NotAllOrders={this.NotAllOrders.bind(this, 'stopOtherOrders')} />
          </Portal>
        )}
        {this.state.stopOrders.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'stopOrders')}>
            <StopOtherOrders Stop={this.state.stopOrders.open} AllOrders={this.AllOrders.bind(this, 'stopOrders')} NotAllOrders={this.NotAllOrders.bind(this, 'stopOrders')} />
          </Portal>
        )}
        {this.state.orderReferenceApprove.open && (
          <Portal className='refOrderApproval_popup' onPortalClose={this.onPortalClose.bind(this, 'orderReferenceApprove')}>
            <ReferenceOrderActionModal
              show={this.state.orderReferenceApprove.open}
              item={item}
              id={item.Id}
              onClose={this.onPortalClose.bind(this, 'orderReferenceApprove')}
              checkForPopups={this.props.checkForPopups}
              department={this.props.auth.departmentType} />
          </Portal>
        )}
        {this.renderConfirm(popupText, 'confirmStart', this.onConfirmStart)}
      </div>
    )
  }

  renderConfirm (text, stateField, onYes, onNo) {
    if (this.state[stateField] === undefined || this.state[stateField].open !== true) return null
    const onClose = () => {
      this.setState({
        [stateField]: { open: false }
      }, () => {
        if (typeof onNo === 'function') {
          onNo()
        }
      })
    }

    const onConfirm = () => {
      this.setState({
        [stateField]: { open: false }
      }, () => {
        if (typeof onYes === 'function') {
          onYes()
        }
      })
    }

    return (
      <Portal className='confirm_popup' onPortalClose={onClose}>
        <Confirm renderText={() => { return (<div>{text}</div>) }} confirm={onConfirm} notConfirm={onClose} />
      </Portal>
    )
  }

  openReferenceApprove () {
    this.props.triggerPopup(true)
    this.setState({
      orderReferenceApprove: {
        open: true,
        id: this.props.item.id
      }
    })
  }

  onReferenceSave (state) {
    if (state === 2) {
      this.setState({
        item: {
          ...this.state.item,
          IsDeleted: true
        }
      })
    } else if (state === 1) {
      this.setState({
        item: {
          ...this.state.item,
          ReferredApproved: true
        }
      })
    }
  }

  AllOrders (type) {
    this.props.triggerPopup(false)
    if (type === 'stopOtherOrders') {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false,
          WorkOnAll: true
        }
      }, () => {
        this.startOrder()
      })
    } else if (type === 'stopOrders') {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false,
          StopAll: true
        }
      }, () => {
        this.stopOrder()
      })
    }
  }

  NotAllOrders (type) {
    this.props.triggerPopup(false)
    if (type === 'stopOtherOrders') {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false,
          WorkOnAll: false
        }
      }, () => {
        this.startOrder()
      })
    } else if (type === 'stopOrders') {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false,
          StopAll: false
        }
      }, () => {
        this.stopOrder()
      })
    }
  }

  onPortalClose (type) {
    this.props.triggerPopup(false)
    this.setState(prevState => ({
      [type]: {
        ...this.state[type],
        open: false
      }
    }))
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  startOrder,
  stopOrder,
  triggerPopup
})(Item)



// WEBPACK FOOTER //
// ./src/app/pages/NewWorkscreen/Item/index.js